import React from "react";
import Rc1 from "../assets/Rc1.png";
import Rc2 from "../assets/Rc2.png";
import Rc3 from "../assets/Rc3.png";
import Rc4 from "../assets/Rc4.png";
import Rc5 from "../assets/Rc5.png";

const benefits = [
  {
    icon: Rc1,
    title: "Faster Reimbursements",
    desc: "Reduce claim processing time and speed up payments",
  },
  {
    icon: Rc2,
    title: "Error-Free Billing",
    desc: "AI-powered automation minimizes claim denials",
  },
  {
    icon: Rc3,
    title: "Regulatory Compliance",
    desc: "Ensure adherence to industry standards and regulations",
  },
  {
    icon: Rc4,
    title: "Improved Cash Flow",
    desc: "Optimize revenue streams and enhance financial efficiency",
  },
  {
    icon: Rc5,
    title: "Seamless Integration",
    desc: "Connect with EHR, HIS, and accounting systems effortlessly",
  },
];

const WiseRCMBenefits = () => {
  return (
   <section className="relative flex justify-center items-center w-full">
  <div className="max-w-7xl w-full grid grid-cols-2 gap-10 items-center">
        {/* Left Section */}
        <div className="relative flex flex-col items-center">
          {/* Text moved slightly left & smaller font size */}
          <div className="absolute top-[35%] left-[25%] transform -translate-x-1/2 text-center z-10">
            <h2 className="text-4xl font-bold text-[#4ba3ff]">WISE RCM</h2>
            <p className="text-white text-lg mt-2 font-semibold">
              Key Benefits
            </p>
          </div>

          {/* Arc container */}
          <div className="relative mt-4 w-[300px] h-[450px]">
           <svg
  className="absolute top-0 left-0"
  width="800"
  height="450"
  viewBox="0 0 800 450"
>
  {/* Semi-circle Arc */}
  <path
    d="M 10 10 A 220 220 0 0 1 10 440"
    fill="none"
    stroke="#fff"
    strokeWidth="2"
  />

  {/* --- Pointers + Connector Lines --- */}

  {/* 1. Top */}
<circle cx="10" cy="10" r="5" fill="#fff" />
<line
  x1="14"
  y1="10"
  x2="490"
  y2="10"
  stroke="#9333ea"
  strokeWidth="2"
  strokeDasharray="2 4"  // smaller dash + closer dots
/>


  {/* 2. Upper-middle */}
  <circle cx="160" cy="125" r="6" fill="#fff" />
  <line
    x1="166"
    y1="125"
    x2="490"
    y2="125"
    stroke="#9333ea"
    strokeWidth="2"
    strokeDasharray="2 4"
  />

  {/* 3. Middle */}
  <circle cx="183" cy="225" r="6" fill="#fff" />
  <line
    x1="189"
    y1="225"
    x2="490"
    y2="225"
    stroke="#9333ea"
    strokeWidth="2"
    strokeDasharray="2 4"
  />

  {/* 4. Lower-middle */}
  <circle cx="163" cy="320" r="6" fill="#fff" />
  <line
    x1="169"
    y1="320"
    x2="488"
    y2="320"
    stroke="#9333ea"
    strokeWidth="2"
    strokeDasharray="2 4"
  />

  {/* 5. Bottom */}
  <circle cx="10" cy="440" r="5" fill="#fff" />
  <line
    x1="14"
    y1="440"
    x2="492"
    y2="440"
    stroke="#9333ea"
    strokeWidth="2"
    strokeDasharray="2 4"
  />
</svg>

          </div>
        </div>

        {/* Right Section */}
      <div className="flex flex-col gap-10">
  {benefits.map((item, index) => (
    <div key={index} className="flex items-start gap-5">
      {/* Outer Purple Dotted Circle */}
      <div className="relative flex items-center justify-center">
        {/* White Circle with Icon */}
        <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center shadow-lg relative z-10">
          <img
            src={item.icon}
            alt={item.title}
            className="w-10 h-10 object-contain"
          />
        </div>

        {/* Dotted Purple Border Layer */}
    {/* Dotted Purple Border Layer */}
<div className="absolute w-20 h-20 flex items-center justify-center">
  <svg
    className="w-full h-full"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="40"
      cy="40"
      r="38"
      stroke="#9333ea"
      strokeWidth="2"
      strokeDasharray="2 4"  // 👈 this makes the 2,4 dashed pattern
    />
  </svg>
</div>
{/* Dotted Purple Border Layer */}
<div className="absolute w-20 h-20 flex items-center justify-center">
  <svg
    className="w-full h-full"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="40"
      cy="40"
      r="38"
      stroke="#9333ea"
      strokeWidth="2"
      strokeDasharray="2 4"  // 👈 this makes the 2,4 dashed pattern
    />
  </svg>
</div>

      </div>

      {/* Text */}
      <div>
        <h3 className="text-xl font-semibold text-[#4ba3ff]">
          {item.title}
        </h3>
        <p className="text-white text-base">{item.desc}</p>
      </div>
    </div>
  ))}
</div>
</div>
    </section>
  );
};

export default WiseRCMBenefits;
